import { Controller } from '@hotwired/stimulus';
import { useWindowResize, useThrottle } from 'stimulus-use';
import { getOffsetTop } from '../tools/getOffsetTop';

const body = document.querySelector('body');
const mobileMenuOverlaySelector = '.alumni-mobile-menu-overlay';

export const create = () => {
	return class extends Controller {
		static targets = ['holder', 'menuToggle', 'nav'];

		connect() {
			this.mobileMenuOverlay = document.querySelector(mobileMenuOverlaySelector);
			this.handleMobileMenuOverlayClick = this.closeMenu.bind(this);
			this.mobileMenuOverlay?.addEventListener('click', this.handleMobileMenuOverlayClick);

			if (this.element) {
				// Scroll direction
				useThrottle(this, { method: 'checkScrollPosition', wait: 100, leading: true, trailing: true });
				window.addEventListener('scroll', this.checkScrollPosition);
			}

			setTimeout(() => {
				useWindowResize(this);
				this.checkScrollPosition();
			}, 0);
		}
		checkScrollPosition = () => {
			this.unpinTarget = document.querySelector('[data-header-unpin]');
			var offset = 100;
			var direction = window.oldScroll > window.scrollY ? 'up' : 'down';
			var isOnTop = window.scrollY <= 0;
			window.oldScroll = window.scrollY;

			if (window.scrollY > offset) {
				// unpin

				setTimeout(() => {
					this.element.parentNode?.classList[direction == 'up' ? 'add' : 'remove']('is-pinned');
					this.element.parentNode?.classList[direction == 'down' ? 'add' : 'remove']('is-unpinned');

					// Add delayed pointer-events-auto class when scrolling up
					if (direction == 'up') {
						setTimeout(() => {
							this.element.parentNode?.classList.add('is-pinned-delayed');
						}, 300);
					} else {
						this.element.parentNode?.classList.remove('is-pinned-delayed');
					}
				}, 10);

				// Remove is-hover immediately when scrolling up (header is unpinned)
				if (direction == 'down') {
					const hoverElements = this.element.querySelectorAll('.is-hover');
					hoverElements.forEach((element) => element.classList.remove('is-hover'));
				}
			} else {
				// pin
				this.element.parentNode?.classList.add('is-pinned');
				this.element.parentNode?.classList.add('is-pinned-delayed');
			}

			if (isOnTop) {
				this.element.parentNode?.classList.add('is-pinned-delayed');
				this.element.parentNode?.classList.remove('is-pinned', 'is-unpinned');
			}

			if (getOffsetTop(this.unpinTarget)) {
				const unpinTop = getOffsetTop(this.unpinTarget);
				const unpinBottom = unpinTop + this.unpinTarget.clientHeight;
				const currentScroll = window.scrollY;
				const headerHeight = this.element.clientHeight || 0;

				// Hide/unpin when the sticky header's top reaches the start of unpinTarget
				const startThreshold = unpinTop - headerHeight;
				const shouldHide = this.unpinTarget && currentScroll >= startThreshold && currentScroll < unpinBottom;
				this.element.parentNode?.classList[shouldHide ? 'add' : 'remove']('is-hidden');
			}
		};

		windowResize = () => {
			this.checkScrollPosition(window);
		};

		// menu
		toggleMenu = (event) => {
			event?.stopPropagation?.();
			if (this.element.classList.contains('is-menu-open')) {
				this.closeMenu();
			} else {
				this.element.classList.add('is-menu-open');
				body?.classList.add('is-menu-open');
				if (this.hasMenuToggleTarget) {
					this.menuToggleTarget.setAttribute('aria-expanded', 'true');
				}
				if (this.hasNavTarget) {
					this.navTarget.classList.add('is-open');
				}
			}
		};

		closeMenu = () => {
			if (!this.element.classList.contains('is-menu-open')) return;
			const navCtrl =
				this.hasNavTarget && this.navTarget
					? this.application.getControllerForElementAndIdentifier(this.navTarget, 'site-nav')
					: null;
			navCtrl?.closeAllSubmenus?.();
			this.element.classList.remove('is-menu-open');
			body?.classList.remove('is-menu-open');
			if (this.hasMenuToggleTarget) {
				this.menuToggleTarget.setAttribute('aria-expanded', 'false');
			}
			if (this.hasNavTarget) {
				this.navTarget.classList.remove('is-open');
			}
			setTimeout(() => {
				if (this.hasHolderTarget) {
					this.holderTarget.classList.remove('is-submenu-open');
				}
			}, 300);
		};

		// Submenu
		toggleSubmenu(e) {
			e.currentTarget.closest('.m-main__item').classList.toggle('is-submenu-open');
		}

		disconnect() {
			window.removeEventListener('scroll', this.checkScrollPosition);
			this.mobileMenuOverlay?.removeEventListener('click', this.handleMobileMenuOverlayClick);
			body?.classList.remove('is-menu-open');
		}
	};
};
